// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(3, 1, 36, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}
.fx-pricing-modal {
  background: white;
  border-radius: 24px;
  width: 100%;
  max-width: 700px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  padding: 32px 40px;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
}
.modal-header h2 {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
}
.modal-close-btn {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  font-size: 20px;
  cursor: pointer;
  color: #3b82f6;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-body {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.form-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.form-group label {
  font-size: 14px;
  font-weight: 500;
  color: #334155;
}
.form-group input,
.custom-select-wrapper {
  width: 100%;
  padding: 12px 16px;
  font-size: 14px;
  color: #475569;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  box-sizing: border-box;
}
.form-group input:focus {
  outline: none;
  border-color: #f97316;
}
.custom-select-wrapper {
  position: relative;
}
.custom-select-wrapper input {
  padding-right: 40px;
}
/* Styling for react-icons */
.custom-select-wrapper .input-icon-right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  font-size: 18px;
  color: #94a3b8;
  pointer-events: none;
}
.final-rate-display {
  font-size: 16px;
  color: #475569;
}
.final-rate-display span {
  color: #94a3b8;
}
.final-rate-value {
  font-size: 24px;
  font-weight: 600;
  color: #1e293b;
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 32px;
}
.cancel-btn,
.set-price-btn {
  padding: 12px 28px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid;
}
.cancel-btn {
  background-color: white;
  color: #475569;
  border-color: #cbd5e1;
}
.set-price-btn {
  background-color: #f97316;
  color: white;
  border-color: #f97316;
}

@media (max-width: 600px) {
  .fx-pricing-modal {
    padding: 8px;
    max-width: 98vw;
  }
  .modal-header,
  .modal-footer {
    padding: 8px;
  }
  .form-row {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/compoonents/SetFxPricingModal/SetFxPricingModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,eAAe;EACf,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,YAAY;IACZ,eAAe;EACjB;EACA;;IAEE,YAAY;EACd;EACA;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF","sourcesContent":[".modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(3, 1, 36, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n  backdrop-filter: blur(5px);\n}\n.fx-pricing-modal {\n  background: white;\n  border-radius: 24px;\n  width: 100%;\n  max-width: 700px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n  padding: 32px 40px;\n}\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 32px;\n}\n.modal-header h2 {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1e293b;\n  margin: 0;\n}\n.modal-close-btn {\n  background: #eff6ff;\n  border: 1px solid #dbeafe;\n  font-size: 20px;\n  cursor: pointer;\n  color: #3b82f6;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n}\n.form-group {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.form-group label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #334155;\n}\n.form-group input,\n.custom-select-wrapper {\n  width: 100%;\n  padding: 12px 16px;\n  font-size: 14px;\n  color: #475569;\n  background-color: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  box-sizing: border-box;\n}\n.form-group input:focus {\n  outline: none;\n  border-color: #f97316;\n}\n.custom-select-wrapper {\n  position: relative;\n}\n.custom-select-wrapper input {\n  padding-right: 40px;\n}\n/* Styling for react-icons */\n.custom-select-wrapper .input-icon-right {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 16px;\n  font-size: 18px;\n  color: #94a3b8;\n  pointer-events: none;\n}\n.final-rate-display {\n  font-size: 16px;\n  color: #475569;\n}\n.final-rate-display span {\n  color: #94a3b8;\n}\n.final-rate-value {\n  font-size: 24px;\n  font-weight: 600;\n  color: #1e293b;\n}\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 16px;\n  margin-top: 32px;\n}\n.cancel-btn,\n.set-price-btn {\n  padding: 12px 28px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  border: 1px solid;\n}\n.cancel-btn {\n  background-color: white;\n  color: #475569;\n  border-color: #cbd5e1;\n}\n.set-price-btn {\n  background-color: #f97316;\n  color: white;\n  border-color: #f97316;\n}\n\n@media (max-width: 600px) {\n  .fx-pricing-modal {\n    padding: 8px;\n    max-width: 98vw;\n  }\n  .modal-header,\n  .modal-footer {\n    padding: 8px;\n  }\n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
